import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getUsersAction,
  resetPasswordAction,
} from "../../Actions/UserAction/UserAction";
import { FaEdit, FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Pagination from "../Pagination";
import { MdLockReset } from "react-icons/md";
// import { AiFillFileImage } from "react-icons/ai";
import { ImProfile } from "react-icons/im";

const Users = () => {
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsersAction(page, perPage));
  }, [dispatch, page, perPage]);
  const navigate = useNavigate();

  const getUsers = useSelector((state) => state.getUsers);
  const { users, total } = getUsers;

  const onPageChange = (event) => {
    setPage(event.selected);
    dispatch(getUsersAction(event.selected + 1, perPage));
  };

  const fields = [
    "English Name",
    "Kurdish Name",
    "Birth Date",
    "Gender",
    "Phone",
    "Second Phone",
    "Close Phone",
    "Email",
    "Married",
    "Number of Children",
    "Blood Group",
    "Date of Communication",
    "Chronic Diseases",
    "Certificate",
    "Certificate Field",
    "Occupation Outside",
    "Work Place",
    "Job Title",
    "English Language",
    "Kurdish Language",
    "Arabic Language",
    "Computer Skills",
    "Branch ID",
    "Position ID",
    "Role ID",
    "Hourly Wage",
    "Extra Wage",
  ];
  // const dispatch=useDispatch();

  return (
    <div className=" p-4">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">Users</h2>
        <button
          onClick={() => navigate("create")}
          className="btn-primary flex items-center gap-2"
        >
          <span>Add User</span>
          <FaPlus />
        </button>
      </div>
      <div className="overflow-hidden border border-gray-200 rounded-lg">
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <TableHeader fields={fields} />
            <TableRow users={users} />
          </table>
        </div>
      </div>
      <Pagination
        total={total}
        perPage={perPage}
        setPerPage={setPerPage}
        onPageChange={onPageChange}
        page={page}
      />
    </div>
  );
};

const TableHeader = ({ fields }) => {
  return (
    <thead className="bg-gray-50">
      <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
        <th>Action</th>
        {fields.map((fieldName, index) => (
          <th key={index} className="py-2 px-3">
            {fieldName}
          </th>
        ))}
      </tr>
    </thead>
  );
};

const TableRow = ({ users }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <tbody className="divide-y divide-gray-200">
      {users?.map((user, index) => (
        <tr key={index} className="text-sm">
          <td className="py-3 px-3">
            <div className="flex gap-2 items-center">
              <button
                className="btn-indigo"
                onClick={() => navigate("update", { state: { user } })}
              >
                Update <FaEdit />
              </button>

              <button
                className="btn-red"
                onClick={() => {
                  dispatch(resetPasswordAction(user.id));
                }}
              >
                Reset <MdLockReset />
              </button>

              <button
                className="btn-blue"
                onClick={() => navigate(`profile/${user.id}`)}
              >
                Profile <ImProfile />
              </button>
            </div>
          </td>
          <td className="py-3 px-3">{user.user_info.en_name}</td>
          <td className="py-3 px-3">{user.user_info.krd_name}</td>
          <td className="py-3 px-3">{user.user_info.birth_date}</td>
          <td className="py-3 px-3">{user.user_info.gender}</td>
          <td className="py-3 px-3">{user.user_info.phone}</td>
          <td className="py-3 px-3">{user.user_info.secound_phone}</td>
          <td className="py-3 px-3">{user.user_info.close_phone}</td>
          <td className="py-3 px-3">{user.email}</td>
          <td className="py-3 px-3">{user.user_info.married}</td>
          <td className="py-3 px-3">{user.user_info.number_of_children}</td>
          <td className="py-3 px-3">{user.user_info.blood_group}</td>
          <td className="py-3 px-3">{user.user_info.date_of_communication}</td>
          <td className="py-3 px-3">{user.user_info.chronic_diseases}</td>
          <td className="py-3 px-3">{user.user_info.certificate}</td>
          <td className="py-3 px-3">{user.user_info.certificate_field}</td>
          <td className="py-3 px-3">{user.user_info.occupation_outside}</td>
          <td className="py-3 px-3">{user.user_info.work_place}</td>
          <td className="py-3 px-3">{user.user_info.job_tiltle}</td>
          <td className="py-3 px-3">{user.user_info.en_lang}</td>
          <td className="py-3 px-3">{user.user_info.krd_lang}</td>
          <td className="py-3 px-3">{user.user_info.ar_lang}</td>
          <td className="py-3 px-3">{user.user_info.computer_skills}</td>
          <td className="py-3 px-3">{user.user_info.branch_id}</td>
          <td className="py-3 px-3">{user.user_info.position_id}</td>
          <td className="py-3 px-3">{user.user_info.role_id}</td>
          <td className="py-3 px-3">{user.user_info.hourly_wage}</td>
          <td className="py-3 px-3">{user.user_info.extra_wage}</td>
        </tr>
      ))}
    </tbody>
  );
};

export default Users;
